export default __webpack_public_path__ + "static/media/sm3.035c1ab4.png";